(function () {
  'use strict';

  /* ============================================================
     Hero-cards overlap
     Mirrors bam-hub-cards.js but targets .traveler-portal-cards
     and the portal-specific .bam-portal-hero banner class.
     ============================================================ */

  var resizeObserver;

  function getHero() {
    return document.querySelector('.banner.bam-portal-hero');
  }

  function getCards() {
    return document.querySelector('.traveler-portal-cards');
  }

  function syncOverlap() {
    var hero = getHero();
    var cards = getCards();
    if (!hero || !cards) return;

    var box = hero.querySelector('.banner__box');
    if (!box) return;

    var heroSection = hero.closest('.shopify-section');
    var cardsSection = cards.closest('.shopify-section');

    if (heroSection) heroSection.classList.add('bam-portal-hero-section');
    if (cardsSection) cardsSection.classList.add('traveler-portal-cards-section');

    // Keep the text-gradient width in sync with the text box width
    hero.style.setProperty(
      '--banner-text-gradient-width',
      Math.ceil(box.getBoundingClientRect().width) + 'px'
    );

    // Reset before measuring
    if (cardsSection) cardsSection.style.marginTop = '';
    cards.style.setProperty('--tp-cards-overlap', '0px');
    void cards.offsetHeight; // force reflow

    var boxBottom = box.getBoundingClientRect().bottom;
    var cardsTop = cards.getBoundingClientRect().top;
    var pull = Math.round(cardsTop - boxBottom);

    if (pull > 0 && cardsSection) {
      cardsSection.style.marginTop = -pull + 'px';
      cards.style.setProperty('--tp-cards-overlap', pull + 'px');
      cards.classList.add('traveler-portal-cards--anchored');
    }
  }

  function initOverlap() {
    var hero = getHero();
    var cards = getCards();
    if (!hero || !cards) return;

    var box = hero.querySelector('.banner__box');
    if (!box) return;

    syncOverlap();

    if (typeof ResizeObserver !== 'undefined') {
      if (resizeObserver) resizeObserver.disconnect();
      resizeObserver = new ResizeObserver(syncOverlap);
      resizeObserver.observe(hero);
      resizeObserver.observe(box);
      resizeObserver.observe(cards);
    } else {
      window.addEventListener('resize', syncOverlap);
    }

    // Re-sync once images finish loading (affects hero height)
    hero.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', syncOverlap, { once: true });
      }
    });
  }

  /* ============================================================
     Login modal
     Auto-opens on load for guests, and on login-required button
     clicks. Login CTA uses return_to so Shopify returns here.
     ============================================================ */

  var DEFAULT_LOGIN_FEATURE = 'adventures, store credit, and more';

  function initLoginModal() {
    var modal = document.getElementById('tp-login-modal');
    if (!modal) return; // Not present when customer is logged in

    var featureEl = modal.querySelector('.tp-login-modal__feature');
    var ctaEl = modal.querySelector('.tp-login-modal__cta');
    var closeBtn = modal.querySelector('.tp-login-modal__close');
    var backdrop = modal.querySelector('.tp-login-modal__backdrop');
    var cards = getCards();
    var defaultLoginUrl = (cards && cards.getAttribute('data-login-url')) || '/account/login';

    // Lift out of the section so the overlay covers the full page
    // (hero, header, and cards), not just this Shopify section.
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    function setModalContext(feature, loginUrl) {
      if (featureEl) featureEl.textContent = feature || DEFAULT_LOGIN_FEATURE;
      if (ctaEl) ctaEl.setAttribute('href', loginUrl || defaultLoginUrl);
    }

    // Open modal on login-required button clicks
    document.querySelectorAll('[data-login-required]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        setModalContext(
          btn.getAttribute('data-feature') || DEFAULT_LOGIN_FEATURE,
          btn.getAttribute('data-login-url') || defaultLoginUrl
        );
        openModal(modal);
      });
    });

    // Close on X button
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeModal(modal);
      });
    }

    // Close on backdrop click
    if (backdrop) {
      backdrop.addEventListener('click', function () {
        closeModal(modal);
      });
    }

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        closeModal(modal);
      }
    });

    // Auto-open for guests on the portal page (skip theme editor)
    var inEditor = window.Shopify && Shopify.designMode;
    if (!inEditor) {
      setModalContext(DEFAULT_LOGIN_FEATURE, defaultLoginUrl);
      openModal(modal);
    }
  }

  function openModal(modal) {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';

    // Move focus into the login CTA for accessibility
    var focusTarget = modal.querySelector('.tp-login-modal__cta') || modal.querySelector('.tp-login-modal__close');
    if (focusTarget) {
      setTimeout(function () { focusTarget.focus(); }, 50);
    }
  }

  function closeModal(modal) {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  /* ============================================================
     Boot
     ============================================================ */

  function init() {
    initOverlap();
    initLoginModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-sync after full page load (fonts, images settled)
  window.addEventListener('load', syncOverlap);

  // Shopify theme editor events
  document.addEventListener('shopify:section:load', function () {
    init();
  });
  document.addEventListener('shopify:section:reorder', syncOverlap);
})();
